export default __webpack_public_path__ + "static/media/Chevron Right.a9215b60.svg";